import { environment } from 'src/environments/environment';
import { HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class UserService {
  private baseUrl = environment.apiUrl;
  private endpointBase = "/api/User/"
  constructor(private http: HttpClient) {}


  getUserByEmail(email:string): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}${this.endpointBase}get_user_by_email?email=`+email)
      .pipe(
        map((response: any[]) => {
          return response;
        })
      );
  }
  
  getUserByID(id:string): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}${this.endpointBase}get_user_by_id?id=`+id)
      .pipe(
        map((response: any[]) => {
          return response;
        })
      );
  }

  getUserByToken(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}${this.endpointBase}get_user_by_token`)
      .pipe(
        map((response: any[]) => {
          return response;
        })
      );
  }

}
